import { useNavigate } from 'react-router-dom';
import { getLocalDate } from '../utils/fn';
import {
  ListItemButton,
  ListItemText,
} from '@mui/material';

const NewsItem = ({ item, pageNum, selected }) => {
  const navigate = useNavigate();
  const handleListItemClick = (newsItem) => {
    let backurl;
    if (pageNum) {
      backurl = `/news/${pageNum}/#${newsItem._id}`;
    } else {
      backurl = '/news';
    }

    if (newsItem?.project && newsItem?.project?.section) {
      navigate(`/crm/${newsItem?.project?.section}/${newsItem?.project?._id}`, {
        replace: true,
        state: { backurl: backurl },
      });
    }

  };

  return (
    <ListItemButton
      id={item?._id}
      selected={selected}
      key={item?._id}
      onClick={() => handleListItemClick(item)}
    >
      <ListItemText
        primary={item?.message}
        secondary={getLocalDate(item?.createdAt)}
      />
    </ListItemButton>
  );
};

export default NewsItem;
